import { z } from "zod";

export enum CommunityContentItemType {
  CommunityChallengeAndSession = "community_challenge_and_session",
  CollectionAndSession = "collection_and_session",
  Campaign = "campaign",
  CommunityDailyAndSession = "community_daily_and_session",
}

export const communityContentItemTypeEnum = z.enum(CommunityContentItemType);
